import { GetStaticProps, NextPage } from "next";
import TermsOfCooperation from "@components/views/TermsOfCooperationView";
import Head from "next/head";

const TermsOfCooperationPage: NextPage = () => {
	return (
		<>
			<Head>
				<title>Запустить свой курс бесплатно — создайте и разместите свой онлайн-курс в Selfschool</title>
				<meta
					name="description"
					content="Запустить свой курс бесплатно - опубликуйте через конструктор для создания и размещения обучающего контента. Размещение платных и бесплатных курсов. Бесплатная поддержка."
				/>
			</Head>
			<TermsOfCooperation />
		</>
	);
};

export const getStaticProps: GetStaticProps = async () => {
	return {
		props: {},
	};
};

export default TermsOfCooperationPage;
